<template>
  <div class="heatmap-container">
    <main>
      <div class="info">
        <h2>{{platformName}}</h2>
        <span>（查看详细数据，请开启热力图）</span>
        <label>访问账号数：</label>
        <span>昨日</span>
        <b>{{homepageUv.yesterday}}</b>
        <span>近7天</span>
        <b>{{homepageUv.sevenDays}}</b>
        <span>近30天</span>
        <b>{{homepageUv.thirtyDays}}</b>
      </div>
      <a-switch @change="onChange" />
    </main>
    <aside v-if="showReportData">
      <div class="item">
        <label>统计时间：</label>
        <a-radio-group name="period" :value="period" @change="onPeriodChange">
          <a-radio :value="30">近30天</a-radio>
          <a-radio :value="7">近7天</a-radio>
          <a-radio :value="1">昨日</a-radio>
        </a-radio-group>
      </div>
      <div class="item">
        <label>数据维度：</label>
        <a-radio-group name="logType" :value="logType" @change="onLogTypeChange">
          <a-radio value="uv">点击账号数</a-radio>
          <a-radio value="pv">点击次数</a-radio>
        </a-radio-group>
      </div>
    </aside>
    <Toast content="点击蒙层可查看TOP使用商家哦～" :visible="visible" />
    <div class="loading" v-if="loading"><a-spin size="large" :spinning="loading" /></div>
    <top-user-modal v-if="showReportData" />
  </div>
</template>
<script>
  // 组件说明：
  // 仅包含：POP、品牌商、供应商
  // 成长加/育儿无此功能
  // 工作台顶部热力图开关组件
  // 包含默认展示工作台访问账号数（昨日、近7天、近30天）
  // 是否打开热力图开关，默认关闭。打开后调接口查询菜单点击统计数据
  // 包括点击账号数和点击次数
  import Toast from './toast.vue'
  import { Switch, Radio, Spin } from 'ant-design-vue'
  import global from '@/mixins/global'
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import TopUserModal from './topUserModal.vue'

  export default {
    components: {
      Toast,
      [Switch.name]: Switch,
      [Radio.name]: Radio,
      [Radio.Group.name]: Radio.Group,
      [Spin.name]: Spin,
      [TopUserModal.name]: TopUserModal
    },
    data() {
      return {
        visible: false,
        toastVisibleTimes: 0,
        platformName: ''
      }
    },
    mixins: [global],
    computed: {
      ...mapState('heatmap', ['loading', 'showReportData', 'homepageUv', 'period', 'logType', 'openedMenuKey'])
    },
    methods: {
      ...mapActions('heatmap', ['getPositionCount', 'handlePeriodChange', 'handleLogTypeChange', 'getHomepageUv', 'initPageID', 'isShowReportData', 'resetPositionCount']),
      async onChange(checked) {
        if (checked) {
          await this.getPositionCount(true)
          this.isShowReportData(true)
          if (this.toastVisibleTimes < 1) {
            // 只显示一次
            this.toastVisibleTimes++
            this.visible = true
            setTimeout(() => {
              this.visible = false
            }, 3000)
          }
        } else {
          this.isShowReportData(false)
        }
      },
      onPeriodChange(e) {
        this.resetPositionCount()
        this.handlePeriodChange(e.target.value)
        this.getPositionCount(true)
      },
      onLogTypeChange(e) {
        this.resetPositionCount()
        this.handleLogTypeChange(e.target.value)
        this.getPositionCount(true)
      },
    },
    created() {
      // 1： 联营POP商家 2：全球购商家 3：品牌商家  4：供应商  5：育儿服务  6：成长加
      const buzzType = _.get(this.userInfo, 'buzzType')
      if (buzzType === 1 || buzzType === 2) {
        this.platformName = 'POP商家工作台首页'
        this.initPageID(121013119)
      } else if (buzzType === 3) {
        this.platformName = '品牌商工作台首页'
        this.initPageID(121013121)
      } else if (buzzType === 4) {
        this.platformName = '自营供应商工作台首页'
        this.initPageID(121013122)
      } else {
        this.platformName = '工作台首页'
      }
      this.getHomepageUv()
    }
  }
</script>
<style lang="scss" scoped>
  .heatmap-container {
    padding: 28px 60px;
    & > main {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info {
        display: flex;
        align-items: center;
        h2 {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          line-height: 32px;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
        label {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin-left: 60px;
          margin-right: 16px;
        }
        b {
          font-size: 24px;
          font-weight: 500;
          color: #1c7ae5;
          line-height: 30px;
          margin-left: 6px;
          margin-right: 24px;
        }
      }
    }
    & > aside {
      display: flex;
      align-items: center;
      margin-top: 30px;
      .item {
        & > label {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin-right: 20px;
        }
        &:not(:first-child) {
          margin-left: 60px;
        }
      }
      
    }
  }
  .ant-radio-wrapper {
    font-size: 16px;
    color: rgba(0,0,0,0.65);
  }
  .loading {
    background-color: #e6f7ff;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    z-index: 9999999;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
</style>
